import type { I18n } from '@lingui/core'
import type { ReactNode } from 'react'
import { useEffect, useState } from 'react'
import { useSubLocale } from './useActivateLocale'
import { useActivateLocale } from './useActivateLocale'
import { I18nProvider as I18nProviderLingui } from '@lingui/react'
import type { Locale } from './locale'

export function SubLocale({
  locale,
  scope,
}: {
  locale: Locale
  scope?: (i18n: I18n) => ReactNode
}) {
  const { i18n, isLoading } = useSubLocale(locale)
  const [children, setChildren] = useState<ReactNode>(null)

  useEffect(() => {
    if (isLoading || !scope) {
      return
    }

    setChildren(scope(i18n))
  }, [isLoading, locale, scope, i18n])

  return <I18nProviderLingui i18n={i18n}>{children}</I18nProviderLingui>
}

export function I18nProvider({
  overrideLocale,
  children,
}: {
  overrideLocale?: Locale
  children: ReactNode
}) {
  const { i18n } = useActivateLocale({
    overrideLocale,
  })
  return <I18nProviderLingui i18n={i18n}>{children}</I18nProviderLingui>
}
